import axios from "axios";
import { cacheManager, callAPI, clearAzureAdAuthCodeAction, cookiesManager, getApiUniqueRequestId, noCookiesRedirectToLogin } from "./helpers/util-common";
import { get } from "lodash";
import * as types from "./action-type";
import getApiUrl from "./helpers/api-urls";
import { decrypt, encrypt, getUserAgent } from "./helpers/util-common";
import { cookieKeysEnum } from "./models/common.models";

export const setLoader = (flag: any) => ({
  type: types.SET_LOADER,
  flag,
});

export const setOverlayLoader = (flag: any) => ({
  type: types.SET_OVERLAY_LOADER,
  flag,
});

export const setminiLoader = (flag: any) => ({
  type: types.SET_MINI_LOADER,
  flag,
});

export const setMessage = (flag: any, code: any, uniqueRequestId = null, message = "") => ({
  type: types.SET_MESSAGE,
  flag,
  code,
  message,
  uniqueRequestId,
});
export const showSuccessToastMesage = (flag: any, code: any, message = "") => ({
  type: types.SHOW_SUCCESS_MESSAGE,
  flag,
  code,
  message,
});

export const showDissmissibleToastMesage = (flag: any, code: any, dismissibleMessage = "", dispatch?: any) => dispatch({ type: types.SHOW_DISMISSIBLE_MESSAGE, flag, code, dismissibleMessage });

export const StorCurrentLocation = (dispatch: any, data: string) => {
  dispatch({ type: types.STORE_CURRENT_LOCATION, data });
};
export const SetExportDataFlag = (dispatch: any, data: boolean) => {
  dispatch({ type: types.EXPORT_BALLOTS_LIST, data });
};
export const resetAdvBallotSearchFormData = (dispatch: any) => {
  dispatch({
    type: types.SET_BALLOT_ADVANCE_FORM_DATA,
    data: {},
  });
};

export const SetBallotDetailTagData = (dispatch: any, data: number) => {
  dispatch({ type: types.SET_BALLOT_DETAIL_TAG, data });
};

export const SetBallotDetailsFromData = (dispatch: any, data: {}) => {
  dispatch({ type: types.SET_BALLOT_DETAILS, data });
};
export const SetBallotListData = (data: {}) => ({
   type: types.SET_BALLOT_LIST, data 
});
export const SetWorkItemListData = (data: {}) => ({
   type: types.SET_WORK_ITEM_LIST, data 
});
export const SetDraftsListData = (data: {}) => ({
  type: types.SET_DRAFTS_LIST, data 
});
export const SetBallotHistoryData = (data: {}) => ({
  type: types.SET_BALLOT_HISTORY_LIST, data 
});
export const SetWorkItemDetailData = (data: {}) => ({
  type: types.SET_WORK_ITEM_DETAIL, data 
});
export const SetDTNDetailData = (data: {}) => ({
  type: types.SET_DTN_DETAIL, data 
});
export const setNavigation = (data: any) => ({
  type: types.SET_NAVIGATION,
  data,
});
export const setPermissionData = (data: any) => ({
  type: types.SET_PERMISSION_DATA,
  data,
});

export const setBallotFlyoutData=(data:any)=>({
  type: types.MANAGE_BALLOT_FLYOUT,
  data,
});

export const setBallotDocumentInfo = (data: any) => ({
  type: types.SET_BALLOT_DOCUMENT_INFO,
  data,
});

export const setBallotTrackingList= (data: any) => ({
  type: types.SET_BALLOT_TRACKING_LIST,
  data,
})

export const setDraftDependencyData = (data: any) => ({
  type: types.SET_DRAFT_DEPENDENCY,
  data,
});
// Action for calling logout.
export const logout = (dispatch: any) => {
  let url = getApiUrl("login", "logout");
  dispatch(setLoader(true));
  axios
    .post(url)
    .then((response) => {
      if (!response?.data?.status) {
        dispatch(setOverlayLoader(false));
      }
      if (response.data.status) {
        // Clear all cache from react app.
        cacheManager.clearSession();
        // Validate if Logout from Azure AD.
        if (process.env.REACT_APP_LOGIN_BY_AZURE_AD == "true") {
          cookiesManager.removeCookie(cookieKeysEnum.APP_SESSIONID);
          setCurrentLocationStorage();
          setTimeout(() => {
            window.location.assign(clearAzureAdAuthCodeAction());
          }, 500);
        } else {
          window.location.assign("/login");
        }
      } else {
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(setMessage(true, response.data.message, uniqueRequestId));
      }
      dispatch(setLoader(false));
    })
    .catch((err) => {
      dispatch(setOverlayLoader(false));
      dispatch(setLoader(false));
      // Custom default code for autologout
      noCookiesRedirectToLogin();
    });
};

export const currentLocationStorage = () => {
  if (cacheManager.getItem("current-location")) {
    return { isLocation: true, location: cacheManager.getItem("current-location") };
  }
  return { isLocation: false, location: null };
};

export const setCurrentLocationStorage = () => {
  if (window.location.href) {
    let location = window.location.href.replace(/.*\/\/[^\/]*/, "");
    let allowedRoutes = ["/renewal-tasks", "/admin", "/user", "/roles", "/member-management", "/committee-management", "/work-item-admin", "/ballot-admin"];
    let isAllowed = allowedRoutes.filter((x) => location.includes(x));
    if (isAllowed && isAllowed.length) {
      cacheManager.setItem("current-location", window.location.href.replace(/.*\/\/[^\/]*/, ""));
    }
  }
};

export const getPermissionOnPageAction = (Input: any, groupInput: any) => ({
  type: types.ALLOW_PERMISSION_FOR_PAGE,
  Input,
  groupInput,
});

// TODO : initiate Azure Request
export const initiateAzureRequestAction = (code: any, sessionState: any, authState: any, cb: any, dispatch: any) => {
  // TODO : Start code for init azure request.
  dispatch(setLoader(true));
  // TODO : Call Request for Init Azure in OSL.
  let url = getApiUrl("login", "initAzure");
  let authCode = encrypt(`${code}:${sessionState}:${decrypt(decodeURIComponent(authState))}`);
  callAPI(url, "post", { code: authCode }, (response: any) => {
    if (!response?.data?.success) {
      dispatch(setOverlayLoader(false));
    }
    if (response.data && response.data.success) {
      cookiesManager.setCookie(cookieKeysEnum.APP_SESSIONID, sessionState);
      cb(true);
    } else {
      dispatch(setLoader(false));
      cb(false);
    }
  });
};
const getOktaToken = (callback) => {
	const url = getApiUrl('login', 'getOktaToken');
	axios.get(url).then((response) => {
		cacheManager.setItem(cookieKeysEnum.oktaToken, response.data);
		if (callback) {
			callback();
		}
	})
		.catch((err) => {
			//dispatch(commonActions.setLoader(false));
		});
}
export const ValidateOktaToken = (callback: any) => {
  let oktaToken = JSON.parse(cacheManager.getItem(cookieKeysEnum.oktaToken));
  if (oktaToken) {
    const now = Math.floor(Date.now() / 1000);
    if (oktaToken.expTime > now) {
      callback(oktaToken.headers)
    }
    else {
      getOktaToken((resposne: any) => {
        oktaToken = JSON.parse(cacheManager.getItem(cookieKeysEnum.oktaToken))
        callback(oktaToken.headers);
      });
    }
  } else {
    getOktaToken(() => {
      oktaToken = JSON.parse(cacheManager.getItem(cookieKeysEnum.oktaToken))
      callback(oktaToken.headers);
    });
  }
}
export const flagFeature = (callback: any, dispatch: any) => {
  let url = getApiUrl("openAPI", "flagFeature", true);
  dispatch(setLoader(true));
  callAPI(url, "get", null, (response: any) => {
    if (!response?.data?.Status) {
      dispatch(setOverlayLoader(false));
    }
    dispatch(setLoader(false));
    if (response.data && response.data.Status) {
      callback(response);
    } else {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(setMessage(true, response.data.Message || "8166", uniqueRequestId));
    }
  });
};

export const getUserPreferencesAction: any = (pageId: number, dispatch: any, callback: (response: any) => void,loader:boolean) => {
  dispatch(setLoader(true));
  let url =`${getApiUrl("userPermission", "getUserPreferences")}/${pageId}` ;  
  axios
    .get(url)
    .then((response) => {
      if (!response?.data?.status) {
        dispatch(setOverlayLoader(false));
      }
      const uniqueRequestId = getApiUniqueRequestId(url);
      !loader && dispatch(setLoader(false));

      if (response.data.status) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(setOverlayLoader(false));
      dispatch(setLoader(false));
    });
};

export const saveUserPreferencesAction: any = (pageId: number,data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(setLoader(true));
  let url = `${getApiUrl("userPermission", "updateGridPreferences")}/${pageId}`;
  axios
    .put(url, data)
    .then((response) => {
      if (!response?.data?.status) {
        dispatch(setOverlayLoader(false));
      }
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(setLoader(false));
      if (response.data.status) {
        dispatch(setMessage(true, "1015", uniqueRequestId));
        callback(response.data.content);
      } else {
        callback({});
        dispatch(setMessage(true, "1016", uniqueRequestId));
        dispatch(setOverlayLoader(false));
      }
    })
    .catch((err) => {
      dispatch(setLoader(false));
      dispatch(setOverlayLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(setMessage(true, "1016", uniqueRequestId));
    });
};

export const showAlertPopup = (flag, data) => ({
  type: types.SHOW_ALERT_POPUP,
  flag,
  data
})

export const hideAlertPopup = (dispatch) => {
  dispatch(showAlertPopup(false, ''));
}

export const setGlobalSearchText = (data: string) => ({
  type: types.SET_GLOBAL_SEARCH_TEXT,
  data,
});

export const setBallotAdvanceSearch = (data: any) => ({
  type: types.SET_BALLOT_ADVANCE_SEARCH,
  data,
});

export const setAdvBallotSearchFormData = (data: any) => ({
  type: types.SET_BALLOT_ADVANCE_FORM_DATA,
  data,
});

export const setAdvWorkitemSearchFormData = (data: any) => ({
  type: types.SET_WI_ADVANCE_FORM_DATA,
  data,
});

export const setQuickSearchSelectedBallotStatus = (data: string) => ({
  type: types.SET_SELECTED_BALLOT_STATUS,
  data,
});

export const resetQuickSearchSelectedBallotStatus = (dispatch: any) => {
  dispatch({
    type: types.SET_SELECTED_BALLOT_STATUS,
    data: "All",
  });
};

export const setQuickSearchSelectedUser = (data: string) => ({
  type: types.SET_QUICK_SEARCH_SELECTED_USER,
  data,
});

export const setQuickSearchSelectedLevel = (data: any) => ({
  type: types.SET_QUICK_SEARCH_SELECTED_LEVEL,
  data,
});

export const resetQuickSearchSelectedLevel = (dispatch: any) => {
  dispatch({
    type: types.SET_QUICK_SEARCH_SELECTED_LEVEL,
    data: [],
  });
};

export const setIsUserOfficer = (data: any) => ({
  type: types.SET_IS_USER_OFFICER,
  data,
});
export const setQuickSearchSelectedWorkItemStatus = (data: any) => ({
  type: types.SET_SELECTED_WORKITEM_STATUS,
  data,
});

export const resetQuickSearchSelectedWorkItemStatus = (dispatch: any) => {
  dispatch({
    type: types.SET_SELECTED_WORKITEM_STATUS,
    data: "All",
  });
};
export const resetQuickSearchSelectedWorkItemType = (dispatch: any) => {
  dispatch({
    type: types.SET_SELECTED_WORKITEM_TYPE,
    data: "All",
  });
};
export const resetQuickSearchSelectedWorkItemSuppress = (dispatch: any) => {
  dispatch({
    type: types.SET_WI_SUPPRESS,
    data: false,
  });
};
export const setQuickSearchSelectedWorkItemType = (data: any) => ({
  type: types.SET_SELECTED_WORKITEM_TYPE,
  data,
});
export const setQuickSearchSelectedWISuppressed = (data: string) => ({
  type: types.SET_WI_SUPPRESS,
  data,
});
export const setWIExtraFields = (data: any) => ({
  type: types.SET_WI_EXTRA_FIELDS,
  data,
});

export const setAllCommittees = (data: any) => ({
  type: types.SET_ALL_COMMITTEES,
  data,
});
export const setActiveCommittees = (data: any) => ({
  type: types.SET_ACTIVE_COMMITTEES,
  data,
});

export const setShowAlertModalForPendingPublicationBallot = (data: any) => ({
  type: types.SET_SHOW_ALERT_MODAL_FOR_PENDINGPUBLICATION_BALLOT,
  data
});

export const setBallotDesignationData = (data: any) => ({
  type: types.SET_BALLOT_DESIGNATION,
  data
});

export const setAnsiCommitteeList = (data: any) => ({
  type: types.SET_ANSI_COMMITTEE_LIST,
  data
});

export const setAnsiStandardList = (data: any) => ({
  type: types.SET_ANSI_STANDARD_LIST,
  data
});

export const setSelectedAnsiCommittee = (data: any) => ({
  type: types.SET_ANSI_SELECTED_COMMITTEE,
  data
});

export const setSelectedAnsiStandard = (data: any) => ({
  type: types.SET_ANSI_SELECTED_STANDARD,
  data
});

export const setAnsiTabIndex = (data: any) => ({
  type: types.SET_ANSI_TAB_INDEX,
  data
});

export const setANSICommittee = (data: any) => ({
  type: types.SET_SELECTED_COMMITTEE,
  data
});

export const setBSR108List = (data: any) => ({
  type: types.SET_BSR108_DATA,
  data
});

export const setBSR109List = (data: any) => ({
  type: types.SET_BSR109_DATA,
  data
});


export const setAnsiAuditLog = (data:{})=>({
  type: types.SET_ANSI_AUDIT_LOG,
  data
})

export const setAnsiDeleteFlow = (data:{})=>({
  type: types.SET_ANSI_DELETE_FLOW,
  data
});

export const setPINSReportsList = (data: any) => ({
  type: types.SET_PINS_REPORTS_DATA,
  data
});

export const setAllANSICommitteeData = (data: any) => ({
  type: types.SET_ALL_ANSI_COMMITTEE_LIST,
  data
});

export const setBSRDeleteFlow = (data:{})=>({
  type: types.SET_BSR_DELETE_FLOW,
  data
});

export default {
  setLoader,
  setminiLoader,
  setMessage,
  showSuccessToastMesage,
  StorCurrentLocation,
  logout,
  getPermissionOnPageAction,
  currentLocationStorage,
  setCurrentLocationStorage,
  initiateAzureRequestAction,
  SetExportDataFlag,
  setBallotAdvanceSearch,
  setAdvBallotSearchFormData,
  setAdvWorkitemSearchFormData,
  SetBallotDetailsFromData,
  setQuickSearchSelectedBallotStatus,
  setQuickSearchSelectedUser,
  setQuickSearchSelectedLevel,
  setIsUserOfficer,
  SetWorkItemListData,
  SetWorkItemDetailData,
  SetDraftsListData,
  SetBallotHistoryData,
  SetDTNDetailData,
  showAlertPopup,
  hideAlertPopup,
  setNavigation,
  setQuickSearchSelectedWorkItemStatus,
  setQuickSearchSelectedWorkItemType,
  setQuickSearchSelectedWISuppressed,
  resetQuickSearchSelectedWorkItemType,
  resetQuickSearchSelectedWorkItemSuppress,
  setWIExtraFields,
  setAllCommittees,
  setPermissionData,
  setBallotFlyoutData,
  setBallotDocumentInfo,
  ValidateOktaToken,
  setBallotDesignationData,
  setActiveCommittees,
  setAnsiCommitteeList,
  setAnsiStandardList,
  setANSICommittee,
  setBSR108List,
  setBSR109List,
  setAnsiAuditLog,
  setAnsiDeleteFlow,
  setPINSReportsList,
  setAllANSICommitteeData,
  setOverlayLoader
};
